export const PROVINCES = {
    AB: {
        name: 'Alberta',
        slug: 'alberta',
    },
    BC: {
        name: 'British Columbia',
        slug: 'british-columbia',
    },
    MB: {
        name: 'Manitoba',
        slug: 'manitoba',
    },
    NB: {
        name: 'New Brunswick',
        slug: 'new-brunswick',
    },
    NL: {
        name: 'Newfoundland and Labrador',
        slug: 'newfoundland-and-labrador',
    },
    NS: {
        name: 'Nova Scotia',
        slug: 'nova-scotia',
    },
    NT: {
        name: 'Northwest Territories',
        slug: 'northwest-territories',
    },
    NU: {
        name: 'Nunavut',
        slug: 'nunavut',
    },
    ON: {
        name: 'Ontario',
        slug: 'ontario',
    },
    PE: {
        name: 'Prince Edward Island',
        slug: 'prince-edward-island',
    },
    QC: {
        name: 'Quebec',
        slug: 'quebec',
    },
    SK: {
        name: 'Saskatchewan',
        slug: 'saskatchewan',
    },
    YT: {
        name: 'Yukon',
        slug: 'yukon',
    },
} as const
Object.freeze(PROVINCES)
export type PROVINCE_CODE = keyof typeof PROVINCES
export type PROVINCES = (typeof PROVINCES)[PROVINCE_CODE]

/**
 * Collection of all the American states.
 */
export const STATES = {
    AL: {
        name: 'Alabama',
        slug: 'alabama',
    },
    AK: {
        name: 'Alaska',
        slug: 'alaska',
    },
    AZ: {
        name: 'Arizona',
        slug: 'arizona',
    },
    AR: {
        name: 'Arkansas',
        slug: 'arkansas',
    },
    CA: {
        name: 'California',
        slug: 'california',
    },
    CO: {
        name: 'Colorado',
        slug: 'colorado',
    },
    CT: {
        name: 'Connecticut',
        slug: 'connecticut',
    },
    DE: {
        name: 'Delaware',
        slug: 'delaware',
    },
    DC: {
        name: 'District of Columbia',
        slug: 'district-of-columbia',
    },
    FL: {
        name: 'Florida',
        slug: 'florida',
    },
    GA: {
        name: 'Georgia',
        slug: 'georgia',
    },
    HI: {
        name: 'Hawaii',
        slug: 'hawaii',
    },
    ID: {
        name: 'Idaho',
        slug: 'idaho',
    },
    IL: {
        name: 'Illinois',
        slug: 'illinois',
    },
    IN: {
        name: 'Indiana',
        slug: 'indiana',
    },
    IA: {
        name: 'Iowa',
        slug: 'iowa',
    },
    KS: {
        name: 'Kansas',
        slug: 'kansas',
    },
    KY: {
        name: 'Kentucky',
        slug: 'kentucky',
    },
    LA: {
        name: 'Louisiana',
        slug: 'louisiana',
    },
    ME: {
        name: 'Maine',
        slug: 'maine',
    },
    MD: {
        name: 'Maryland',
        slug: 'maryland',
    },
    MA: {
        name: 'Massachusetts',
        slug: 'massachusetts',
    },
    MI: {
        name: 'Michigan',
        slug: 'michigan',
    },
    MN: {
        name: 'Minnesota',
        slug: 'minnesota',
    },
    MS: {
        name: 'Mississippi',
        slug: 'mississippi',
    },
    MO: {
        name: 'Missouri',
        slug: 'missouri',
    },
    MT: {
        name: 'Montana',
        slug: 'montana',
    },
    NE: {
        name: 'Nebraska',
        slug: 'nebraska',
    },
    NV: {
        name: 'Nevada',
        slug: 'nevada',
    },
    NH: {
        name: 'New Hampshire',
        slug: 'new-hampshire',
    },
    NJ: {
        name: 'New Jersey',
        slug: 'new-jersey',
    },
    NM: {
        name: 'New Mexico',
        slug: 'new-mexico',
    },
    NY: {
        name: 'New York',
        slug: 'new-york',
    },
    NC: {
        name: 'North Carolina',
        slug: 'north-carolina',
    },
    ND: {
        name: 'North Dakota',
        slug: 'north-dakota',
    },
    OH: {
        name: 'Ohio',
        slug: 'ohio',
    },
    OK: {
        name: 'Oklahoma',
        slug: 'oklahoma',
    },
    OR: {
        name: 'Oregon',
        slug: 'oregon',
    },
    PA: {
        name: 'Pennsylvania',
        slug: 'pennsylvania',
    },
    RI: {
        name: 'Rhode Island',
        slug: 'rhode-island',
    },
    SC: {
        name: 'South Carolina',
        slug: 'south-carolina',
    },
    SD: {
        name: 'South Dakota',
        slug: 'south-dakota',
    },
    TN: {
        name: 'Tennessee',
        slug: 'tennessee',
    },
    TX: {
        name: 'Texas',
        slug: 'texas',
    },
    UT: {
        name: 'Utah',
        slug: 'utah',
    },
    VT: {
        name: 'Vermont',
        slug: 'vermont',
    },
    VA: {
        name: 'Virginia',
        slug: 'virginia',
    },
    WA: {
        name: 'Washington',
        slug: 'washington',
    },
    WV: {
        name: 'West Virginia',
        slug: 'west-virginia',
    },
    WI: {
        name: 'Wisconsin',
        slug: 'wisconsin',
    },
    WY: {
        name: 'Wyoming',
        slug: 'wyoming',
    },
} as const
Object.freeze(STATES)
export type STATES = (typeof STATES)[keyof typeof STATES]

/**
 * Collection of all the Canadian provinces and territories and American states.
 */
export const COMBINED_REGIONS = { ...PROVINCES, ...STATES } as const
Object.freeze(COMBINED_REGIONS)
export type COMBINED_REGIONS = (typeof COMBINED_REGIONS)[keyof typeof COMBINED_REGIONS]



export const REGION_EN_TO_FR = {
    california: "californie",
    florida: "floride",
    georgia: "georgie",
    louisiana: "louisiane",
    "district-of-columbia": "district-de-columbia",
    "new-mexico": "nouveau-mexique",
    "new-york": "etat-de-new-york",
    "north-carolina": "caroline-du-nord",
    "south-carolina": "caroline-du-sud",
    "north-dakota": "dakota-du-nord",
    "south-dakota": "dakota-du-sud",
    "west-virginia": "virginie-occidentale",
    pennsylvania: "pennsylvanie",
    virginia: "virginie",
    "british-columbia": "colombie-britannique",
    "new-brunswick": "nouveau-brunswick",
    "newfoundland-and-labrador": "terre-neuve-et-labrador",
    "northwest-territories": "territoires-du-nord-ouest",
    "nova-scotia": "nouvelle-ecosse",
    "prince-edward-island": "ile-du-prince-edouard",
} as const
Object.freeze(REGION_EN_TO_FR)
export type REGION_EN_TO_FR = (typeof REGION_EN_TO_FR)[keyof typeof REGION_EN_TO_FR]